import React, { ReactElement } from 'react';
import { ApolloError } from '@apollo/client';
import { Modal } from '@odin-labs/components';
import {
  GetScheduleDetailsDocument,
  useDeleteScheduleShiftMutation,
} from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { ScheduleShift } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import { AlertService } from 'components/alertService';
import { TrashIcon } from 'components/icons';

export function DeleteShiftModal(props: {
  isOpen: boolean;
  closeModal: () => void;
  shift: ScheduleShift;
}): ReactElement {
  const { isOpen, closeModal, shift } = props;

  const [deleteScheduleShift, { loading }] = useDeleteScheduleShiftMutation({
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      closeModal();
      AlertService.alert(
        'success',
        'Success',
        'Schedule shift deleted successfully',
      );
    },
    onError: (responseError: ApolloError) => {
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(responseError),
      );
    },
    variables: { id: shift.id },
    refetchQueries: [GetScheduleDetailsDocument],
  });

  return (
    <Modal
      actionButtonTheme="danger"
      actionButtonWithSpinner={loading}
      actionIcon={TrashIcon}
      actionText="Confirm"
      onAction={deleteScheduleShift}
      open={isOpen}
      setOpen={closeModal}
      size="xs"
      textAlignment="center"
      title="Are you sure you want to remove this shift?"
      titleAlignment="center"
    />
  );
}
